/** Coarse cosmetic humanoid physics, in world metres and seconds. */
export const deathRagdoll = {
  step: 1 / 60, maxSteps: 12, maxSeconds: 3.5, quietSeconds: .35,
  linearQuiet: .08, angularQuiet: .15, activeLimit: 24,
  linearDamping: 1.6, angularDamping: 2.5, friction: .85,
  impulseSpeed: .8, criticalSpeed: .35, hingeTravel: 1.8,
  damageImpulse: 4, maxHitSpeed: 2.4,
  toppleSpeed: 3.2,
  /** Share and limits of the living flinch velocity inherited by the free body. */
  flinchCarry: .35, maxFlinchSpeed: 1.5, maxFlinchSpin: 6,
  /** A blow that knocks a unit Prone pushes it with this share of the impulse the same damage gives a killing blow. */
  proneImpulse: .5,
  groundReach: 6,
} as const;
